import { animate, query, sequence, style, transition, trigger } from '@angular/animations';

const DURATION = '700ms';
const EASING = 'ease-in-out';

/**
 * Text enters from the bottom and leaves back out through the bottom. Both use
 * the same edge, so the two slides are sequenced — the old one clears before
 * the new one rises, instead of crossing through it.
 */
export const highlightTextAnimation = trigger('highlightText', [
  transition(':increment, :decrement', [
    query(':enter', style({ opacity: 0, transform: 'translateY(100%)' }), { optional: true }),
    sequence([
      query(':leave', [animate(`${DURATION} ${EASING}`, style({ opacity: 0, transform: 'translateY(100%)' }))], { optional: true }),
      query(':enter', [animate(`${DURATION} ${EASING}`, style({ opacity: 1, transform: 'translateY(0)' }))], { optional: true }),
    ]),
  ]),
]);

/**
 * Image slides off the screen before the next one slides back in from the same
 * edge. `edge` is a param so the direction can be mirrored in RTL — animations
 * cannot use logical properties.
 */
export const highlightImageAnimation = trigger('highlightImage', [
  transition(
    ':increment, :decrement',
    [
      query(':enter', style({ opacity: 0, transform: 'translateX({{ edge }})' }), { optional: true }),
      sequence([
        query(':leave', [animate(`${DURATION} ${EASING}`, style({ opacity: 0, transform: 'translateX({{ edge }})' }))], { optional: true }),
        query(':enter', [animate(`${DURATION} ${EASING}`, style({ opacity: 1, transform: 'translateX(0)' }))], { optional: true }),
      ]),
    ],
    { params: { edge: '100%' } }
  ),
]);
